const apiUrl = process.env.REACT_APP_API_URL;

export const PostSprint = async (idProjecte: string, sprint: any) => {
    try {
        const response = await fetch(`${apiUrl}:8061/projectes/${idProjecte}/sprints`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(sprint),
        });

        // Accept both 200 and 201 as success
        return response.ok || response.status === 201;
    } catch (error) {
        console.error('Error al guardar el sprint:', error);
        return false;
    }
};
